export const isMyLaneView = () => {
  const { pathname } = window.location;
  return pathname.includes('myLanes');
};

export const isFindLoadsView = () => {
  const { pathname } = window.location;
  return pathname.includes('findLoads');
};

export const viewState = () => {
  const { pathname, search } = window.location;
  const params = new URLSearchParams(search);
  const loadId = params.get('id');
  const laneIndex = params.get('lane');

  return {
    loadId,
    view: pathname.includes('myLanes') ? 'myLane' : 'findLoads',
    laneIndex: laneIndex,
  };
};
